import React from 'react';
import { useParams } from 'react-router-dom';
import VerbGameWhoDidIt from './VerbGameWhoDidIt';

export default function JuniorHighGrammarGameRoute() {
  const { subject, gameId } = useParams();
  const backUrl = subject ? `/junior-high/${subject}/grammar` : '/junior-high/grammar';

  if (gameId === 'who-did-it-singular') {
    return <VerbGameWhoDidIt gameType="junior-who-did-it-singular" backUrlOverride={backUrl} />;
  }

  return (
    <div className="App">
      <header className="App-header">
        <h1>המשחק לא נמצא</h1>
      </header>
    </div>
  );
}
